import { render } from "./CatProyectoView.vue?vue&type=template&id=1150e5d0&scoped=true"
import script from "./CatProyectoView.vue?vue&type=script&lang=js"
export * from "./CatProyectoView.vue?vue&type=script&lang=js"

import "./CatProyectoView.vue?vue&type=style&index=0&id=1150e5d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1150e5d0"]])

export default __exports__